export default {
  root: {
    padding: '0px 20px',
  },
};
